import { ReactNode } from 'react'
import { Box } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { DataGrid, DataGridProps, GridColDef } from '@mui/x-data-grid'
import { SingleSelectRow } from './types'

interface SingleSelectTableProps<T extends SingleSelectRow> {
  rows: T[]
  columns: GridColDef[]
  dataGridProps: Omit<DataGridProps, 'columns' | 'rows'>
  isLoading: boolean
  isAddActionLoading: boolean
  isAddActionDisabled?: boolean
  addLabel: string
  onAddActionClick: () => void
  addDialog: ReactNode
}

const SingleSelectTable = <T extends SingleSelectRow>({
  rows,
  columns,
  dataGridProps,
  isLoading,
  isAddActionLoading,
  isAddActionDisabled = false,
  addLabel,
  onAddActionClick,
  addDialog,
}: SingleSelectTableProps<T>) => {
  return (
    <Box display="flex" flexDirection="column" width="100%" height="100%">
      <Box flex={1} minHeight={0}>
        <DataGrid
          {...dataGridProps}
          columns={columns}
          rows={rows}
          loading={isLoading}
          disableSelectionOnClick
          hideFooterSelectedRowCount
          sx={{
            height: '100%',
            '& .MuiDataGrid-virtualScroller': {
              overflowX: 'auto',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
              {
                outline: 'none',
              },
          }}
        />
      </Box>

      <Box display="flex" justifyContent="flex-end" pt={2}>
        <LoadingButton
          variant="contained"
          loading={isAddActionLoading}
          disabled={isAddActionDisabled}
          onClick={onAddActionClick}
        >
          {addLabel}
        </LoadingButton>
      </Box>

      {addDialog}
    </Box>
  )
}

export default SingleSelectTable
